import { AbstractMFAFactorModel, AbstractMFAFactorModelModelOptions } from './AbstractMFAFactorModel';

export class SMSMFAModel extends AbstractMFAFactorModel {
  name: string;

  constructor(options: AbstractMFAFactorModelModelOptions) {
    super(options);
    this.name = 'SMS/Text';
  }
  async sendSMS() {
    const client = this.options.clients.provisionAccountsV5Client();
    return client.sendMFASMS({ factor_id: this.id });
  }
}
